import { Component, OnInit } from '@angular/core';
import { BidListStateService } from '../../services/bid-list-state-service/bid-list-state.service';
import { CommonListComponent } from '../common-list/common-list.component';

@Component({
    selector: 'app-bidlist',
    templateUrl: './bidlist.component.html',
    styleUrls: ['./bidlist.component.scss'],
    imports: [CommonListComponent]
})
export class BidlistComponent implements OnInit {

  constructor(
		readonly bidListStateService: BidListStateService
  ) {}

  ngOnInit() {
    this.bidListStateService.isSharedList = false;
  }
}
